import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownArrowGrey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 14.5,
			fill: "white",
			stroke: "#C6CCDA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.35355 12.8146L10.7678 11.4004L15.0607 15.6933L19.3536 11.4004L20.7678 12.8146L15.0607 18.5217L9.35355 12.8146Z",
			fill: "#757783"
		})
	]
});
const ForwardRef = forwardRef(SvgDownArrowGrey);
export default ForwardRef;
